import React, { FC } from "react";
import {
  enquiryFields,
  questionFields,
  questionSetFields,
  riskProfileFields,
} from "kw/api/fragments";

import { AdminGenericFlowButton } from "./AdminGenericFlowModal";
import { TButtonProps } from "kanopi-components/Button";

type TAdminAdjustQuoteButton = {
  quote: TQuote;
  onSuccess: () => void;
  buttonTitle?: string;
  modalTitle?: string;
  finalButtonText?: string;
  prefix?: string;
  finishedRoute?: string;
} & TButtonProps;

export const AdminAdjustQuoteButton: FC<TAdminAdjustQuoteButton> = ({
  quote,
  finalButtonText = "Adjust quote",
  prefix = `/admin/quotes/${quote?.id}`,
  finishedRoute = `/admin/quotes/${quote?.id}`,
  ...props
}) => {
  const actionQuery = {
    admin: {
      startAdjustment: [
        {
          input: {
            riskProfileId: quote?.riskProfile?.id,
          },
        },
        {
          currentEnquiry: {
            ...enquiryFields,
            questionSet: {
              ...questionSetFields,
              questions: {
                ...questionFields,
              },
            },
          },
          history: {
            questionSet: {
              id: true,
              key: true,
              label: true,
            },
          },
          riskProfile: {
            ...riskProfileFields,
          },
          maxSets: true,
          currentSet: true,
        },
      ],
    },
  };

  const questionFlowResponseKey = "admin.startAdjustment";

  return (
    <AdminGenericFlowButton
      quote={quote}
      finalButtonText={finalButtonText}
      prefix={prefix}
      finishedRoute={finishedRoute}
      actionQuery={actionQuery}
      questionFlowResponseKey={questionFlowResponseKey}
      {...props}
    />
  );
};
